import { ArrowRightIcon } from "Icons/ArrowRight";

import React, { useEffect } from "react";

import { css } from "@emotion/react";

import { Button } from "components/shared/library/Button";
import { Divider } from "components/shared/library/Divider";
import { Typography } from "components/shared/library/Typography";

import { useAuth } from "contexts/authContext";

import { useQuerySearchedJobs } from "apis/jobs";

import { useJobSearch } from "utils/jobsSearch";
import { down } from "utils/mediaQueryStrings";

import { black, purple, uiGray, white } from "constants/colors";

import { JobLoadingSkeleton } from "./JobLoadingSkeleton";
import { JobPreviewCard } from "./JobPreviewCard";

const style = {
  card: css({
    borderRadius: 16,
    background: white,
    padding: 24,
    gap: 24,
    display: "flex",
    flexDirection: "column",
  }),
  header: css({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: 8,
    [down("smallMobile")]: { flexWrap: "wrap" },
  }),
  title: css({
    display: "flex",
    flexDirection: "column",
    gap: 8,
    minWidth: "167px",
  }),
  divider: css({
    margin: "8px 0",
  }),
  jobPreviewCard: css({
    "&:hover": {
      background: purple[50],
      borderRadius: 8,
    },
  }),
};

export const JobsYouMightLike = () => {
  const { user } = useAuth();
  const { jobs, fetchJobs, isLoadingMore } = useQuerySearchedJobs(3);
  const { upsertJobSearchFilter, upsertJobIdValue } = useJobSearch();

  useEffect(() => {
    fetchJobs({ search: { filters: { tailored: "forYou" } } });
  }, [fetchJobs]);

  return (
    <div css={style.card}>
      <div css={style.header}>
        <div css={style.title}>
          <Typography size="L" weight="bold" color={black}>
            {user ? "Jobs you might like" : "Trending jobs"}
          </Typography>
          <Typography size="XS" color={uiGray[70]}>
            {user
              ? "Based on your profile and search history"
              : "Sign up to get personalized job recommendations"}
          </Typography>
        </div>
      </div>

      <div>
        {isLoadingMore && (
          <>
            <JobLoadingSkeleton />
            <Divider customCss={style.divider} />
            <JobLoadingSkeleton />
            <Divider customCss={style.divider} />
            <JobLoadingSkeleton />
            <Divider customCss={style.divider} />
          </>
        )}
        {jobs.map((job) => (
          <React.Fragment key={job.jobId}>
            <JobPreviewCard
              job={job}
              onClick={() => {
                upsertJobIdValue(job.jobId);
              }}
              customCss={style.jobPreviewCard}
            />
            <Divider customCss={style.divider} />
          </React.Fragment>
        ))}
        <Button
          onClick={() => upsertJobSearchFilter("tailored", "forYou")}
          IconRight={ArrowRightIcon}
          background="ghost"
          color="black"
          size="medium"
          isFullWidth
        >
          Show all
        </Button>
      </div>
    </div>
  );
};
